import {
  COLOR_GREEN_900,
  COLOR_NEUTRAL_700,
  COLOR_BLUE_700,
  COLOR_BLUE_900,
  COLOR_NEUTRAL_300,
  COLOR_BLUE_600,
  COLOR_GREEN_600
} from '@alltrails/denali/tokens';
import { createPinMarker } from './svgMarkerComponents';

const getFill = (isActive = false, isClosed = false, isCustomRoute = false, isSaved = false) => {
  if (isClosed) {
    return isActive ? COLOR_GREEN_600 : COLOR_NEUTRAL_300;
  }
  if (isCustomRoute) {
    return isActive ? COLOR_BLUE_900 : COLOR_BLUE_700;
  }
  if (isSaved && !isActive) {
    return COLOR_BLUE_600;
  }
  if (isActive) {
    return COLOR_GREEN_600;
  }
  return COLOR_GREEN_900;
};

const createTrailPinSvg = (
  imageName: string,
  trailCount: number,
  isActive: boolean,
  isClosed?: boolean,
  isCustomRoute?: boolean,
  isSaved?: boolean
) => {
  const innerFill = getFill(isActive, isClosed, isCustomRoute, isSaved);
  const closedTextFill = isClosed && !isActive ? COLOR_NEUTRAL_700 : undefined;
  return createPinMarker({
    imageName,
    innerFill,
    dashFill: closedTextFill,
    numberContent: trailCount > 1 && !isCustomRoute ? trailCount : undefined,
    renderInnerDot: !isClosed && trailCount === 1,
    renderInnerDash: isClosed && trailCount === 1,
    textFill: closedTextFill,
    renderInnerBookmark: isSaved && trailCount === 1
  });
};

export default createTrailPinSvg;
